import React from 'react';
import { motion } from 'framer-motion';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';

interface FeatureDisabledMessageProps {
  featureName: string;
  reason?: string;
  canContact?: boolean;
}

/**
 * Message component shown when a feature is globally disabled
 * Used for features that are temporarily unavailable or under maintenance
 */
export const FeatureDisabledMessage: React.FC<FeatureDisabledMessageProps> = ({
  featureName,
  reason = "This feature is temporarily unavailable",
  canContact = true
}) => {
  return (
    <div className="flex items-center justify-center min-h-[400px] p-8">
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.4 }}
        className="bg-white/5 backdrop-blur-sm border border-white/20 rounded-xl p-8 max-w-md text-center"
      >
        <div className="w-16 h-16 mx-auto mb-4 bg-yellow-500/20 rounded-full flex items-center justify-center">
          <ExclamationTriangleIcon className="w-8 h-8 text-yellow-400" />
        </div>
        
        <h3 className="text-2xl font-bold text-white mb-2">
          {featureName} Unavailable
        </h3>
        
        <p className="text-white/70 mb-6">
          {reason}
        </p>
        
        {canContact && (
          <p className="text-white/50 text-sm">
            If you believe this is an error, please contact support.
          </p>
        )}
      </motion.div>
    </div>
  );
};

export default FeatureDisabledMessage;
